import { MORE_LINKS } from '@/components/layout/mobile-nav/mobileNavConfig'
import { ActionSheet } from '@/components/ui'
import { useTheme } from '@/hooks/ui/useTheme'
import {
  CardSingleIcon,
  CardMultipleIcon,
  EyeOpenIcon,
  EyeClosedIcon,
  ExternalLinkIcon,
  FeedbackIcon,
  LogOutIcon,
} from '@/icons'
import { useAuthStore } from '@/store/authStore'
import { useFilterStore } from '@/store/filterStore'

function ViewSettings() {
  const { showHidden, toggleShowHidden, collapseVariants, toggleCollapseVariants } = useFilterStore()

  return (
    <div className="px-4 pt-1 pb-3">
      <div className="flex gap-2">
        <button
          onClick={toggleCollapseVariants}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm font-medium transition-colors ${
            collapseVariants ? 'bg-blue-600 text-white' : 'bg-well text-secondary'
          }`}
        >
          {collapseVariants ? <CardMultipleIcon className="w-4 h-4" /> : <CardSingleIcon className="w-4 h-4" />}
          {collapseVariants ? 'Player' : 'Collector'}
        </button>
        <button
          onClick={toggleShowHidden}
          className={`flex-1 flex items-center justify-center gap-2 py-2.5 rounded-lg text-sm font-medium transition-colors ${
            showHidden ? 'bg-yellow-600 text-white' : 'bg-well text-secondary'
          }`}
        >
          {showHidden ? <EyeOpenIcon className="w-4 h-4" /> : <EyeClosedIcon className="w-4 h-4" />}
          {showHidden ? 'Showing All' : 'Filtered'}
        </button>
      </div>
    </div>
  )
}

interface MobileMoreSheetProps {
  isOpen: boolean
  onClose: () => void
  onOpenFeedback: () => void
  onLogout: () => void
}

export function MobileMoreSheet({ isOpen, onClose, onOpenFeedback, onLogout }: MobileMoreSheetProps) {
  const user = useAuthStore((s) => s.user)
  const { toggleTheme, ThemeIcon, themeLabel } = useTheme()

  return (
    <ActionSheet isOpen={isOpen} onClose={onClose}>
      {/* View settings */}
      <ViewSettings />

      <div className="border-t border-theme-border" />

      {/* Navigation links */}
      <ActionSheet.Actions>
        {MORE_LINKS.map((link) => (
          <ActionSheet.LinkAction key={link.to} to={link.to} icon={link.icon} label={link.label} onClick={onClose} />
        ))}
      </ActionSheet.Actions>

      <div className="border-t border-theme-border" />

      {/* App settings & account */}
      <ActionSheet.Actions>
        {user?.admin && <ActionSheet.LinkAction to="/admin" icon={ExternalLinkIcon} label="Admin" onClick={onClose} />}
        <ActionSheet.Action
          icon={FeedbackIcon}
          iconColor="text-muted"
          label="Send Feedback"
          onClick={() => {
            onClose()
            onOpenFeedback()
          }}
        />
        <ActionSheet.Action
          icon={ThemeIcon}
          iconColor="text-muted"
          label={`Theme: ${themeLabel}`}
          onClick={toggleTheme}
        />
        <ActionSheet.Action icon={LogOutIcon} iconColor="text-red-400" label="Log Out" onClick={onLogout} />
      </ActionSheet.Actions>

      <ActionSheet.Cancel onClose={onClose} />
    </ActionSheet>
  )
}
